import {
    expenseFulfilledConstants,
    expensePendingConstants,
    expenseRejectedConstants
} from '../actions';

const initialState = {
    startDate: null,
    endDate: null,
    officeIds: [],
    officeState: 2,
    resourceOwnerIds: [],
    resourceOwnerState: 2,
    loading: true,
    error: ''
};

export default function expenseFilterReducer(state = initialState, action) {

    switch (action.type) {
        case expensePendingConstants.EXPENSE_LOADED:
            return {
                ...state,
                loading: true
            };
        case expenseFulfilledConstants.EXPENSE_LOADED:
            return {
                ...state,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                officeIds: action.payload.officeIds,
                officeState: action.payload.officeState,
                resourceOwnerIds: action.payload.resourceOwnerIds,
                resourceOwnerState: action.payload.resourceOwnerState,
                loading: false,
                error: '',
            };
        case expensePendingConstants.EXPENSE_CREATED:
            return {
                ...state,
                loading: true
            };
        case expenseFulfilledConstants.EXPENSE_CREATED:
            return {
                ...state,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                officeIds: action.payload.officeIds,
                officeState: action.payload.officeState,
                resourceOwnerIds: action.payload.resourceOwnerIds,
                resourceOwnerState: action.payload.resourceOwnerState,
                loading: false
            };
        case expensePendingConstants.EXPENSE_UPDATED:
            return {
                ...state,
                loading: true
            };
        case expenseFulfilledConstants.EXPENSE_UPDATED:
            return {
                ...state,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                officeIds: action.payload.officeIds,
                officeState: action.payload.officeState,
                resourceOwnerIds: action.payload.resourceOwnerIds,
                resourceOwnerState: action.payload.resourceOwnerState,
                loading: false
            };
        case expensePendingConstants.EXPENSE_DELETE:
            return {
                ...state,
                loading: true
            };

        case expenseFulfilledConstants.EXPENSE_DELETE:
            return {
                ...initialState,
                loading: false
            };
        case expenseRejectedConstants.EXPENSE_CREATED:
        case expenseRejectedConstants.EXPENSE_UPDATED:
        case expenseRejectedConstants.EXPENSE_DELETE: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    loading: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    loading: false,
                    error: error.message
                };
            }

            return state;
        }
        case expenseRejectedConstants.EXPENSE_LOADED: {
            const error = action.payload;
            return {
                ...initialState,
                loading: false,
                error: error.response ? `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}` :
                    error.message
            };
        }

        default:
            break;
    }

    return state;
}
